import React from "react";
import { IconButton, useCopyToClipboard } from "@SeemplicityDev/shared";

interface CopyTableButtonProps {
  tableRef: React.RefObject<HTMLTableElement>;
}

const CopyTableButton: React.FC<CopyTableButtonProps> = ({ tableRef }) => {
  const { copyLabel, copyRichText } = useCopyToClipboard();

  const handleCopy = async () => {
    const tableEl = tableRef.current;
    if (!tableEl) {
      return;
    }

    const htmlContent = tableEl.outerHTML;
    const plainText = tableEl.textContent || "";
    await copyRichText(plainText, htmlContent);
  };

  return (
    <div className="table-copy-btn">
      <IconButton
        data-testid="copy-table-btn"
        isIcon="seem-icon-copy"
        buttonStyle="secondary"
        size="xxs"
        isGhost
        onClick={handleCopy}
        withTooltip={{ content: copyLabel }}
      />
    </div>
  );
};

export default CopyTableButton;
